<template>
  <div>
    <div class="row my-4 align-items-center">
      <div class="col-lg-8">
        <div class="row">
          <div class="col-lg-6">
            <vue-select
              name="periodo"
              v-model="periodo"
              class="select-periodo"
              :clearable="false"
              :options="optionsPeriodo"
              label="label"
              placeholder="Período"
              @input="onChangePeriodo"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
          <div class="col-lg-6">
            <vue-select
              id="select-indicador"
              name="indicador"
              v-model="indicador"
              class="select-indicador"
              :clearable="false"
              :options="optionsIndicador"
              label="label"
              placeholder="Indicador"
              @input="onChangeIndicador"
            >
              <template slot="option" slot-scope="option">
                {{ option.label }}
              </template>
              <div slot="no-options">Não há opções correspondentes</div>
            </vue-select>
          </div>
          <div class="col-lg-8">
            <b-form-group label="" v-slot="{ ariaDescribedby }">
              <b-form-group label="" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  id="radio-group-1"
                  v-model="selectedFiltro"
                  :options="optionsCheckbox"
                  :aria-describedby="ariaDescribedby"
                  name="filtro"
                  class="mt-3"
                  @change="onChangeFiltro"
                ></b-form-radio-group>
              </b-form-group>
            </b-form-group>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <download-files
          :callback-pdf="generatePdf"
          :data="dadosDaTabela"
          :fields="dataFieldsPercentual"
          name="resultado-municipal-percentual"
          class="float-right"
        >
        </download-files>
      </div>
    </div>
    <v-app class="app-tabela">
      <div class="box" style="margin-top: 0px">
        <v-card class="tabela">
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar por CNES, UBS ou INE"
              class="input-bottom"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            @pagination="getPagination"
            :page="currentPage"
            :footer-props="{
              itemsPerPageText: '',
              'items-per-page-options': [10],
              'disable-items-per-page': true,
            }"
            :loading="loading"
            loading-text="Carregando, Por favor espere"
            :headers="headers"
            :items="dadosDaTabela"
            :item-class="getRowColor"
            :search="search"
            :single-expand="true"
            :expanded.sync="expanded"
            item-key="id"
            class="elevation-1"
            show-expand
          >
            <template v-slot:item.resultado="{ item }">
              {{ item.resultado !== '' ? `${item.resultado}%` : '' }}
            </template>

            <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->

            <template v-slot:expanded-item="{ headers, item }">
              <td colspan="6">
                <table class="table table-interna">
                  <thead>
                    <tr>
                      <th>Cidadãos</th>
                      <th>Período</th>
                      <th>Atenção</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div class="d-block mb-2">
                          {{ item.cidadaos }}
                        </div>
                      </td>
                      <td>
                        <div class="d-block mb-2">
                          {{ item.mes_ano }}
                        </div>
                      </td>
                      <td>
                        <div class="d-block mb-2">
                          {{ item.recomendacao_resultado }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </template>

            <template v-slot:[`footer.page-text`]="items">
              <div class="info-table-item tabela-esus-pec">
                <FonteSincronizadorC />
              </div>
              <span class="paginacao"
                >{{ items.pageStart }} - {{ items.pageStop }} de
                {{ items.itemsLength }} registros</span
              >
            </template>

            <template v-slot:progress>
              <v-progress-linear
                color="blue"
                :height="10"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-slot:no-data>
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
              </div>
            </template>
            <template v-slot:no-results style="padding: 0px">
              <div class="alert alert-info mb-0">
                <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-app>
  </div>
</template>

<script>
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
import { dataFieldsPercentual, optionsIndicador } from './utils.js'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    DownloadFiles,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'CNES',
          align: 'start',
          filterable: true,
          value: 'nu_cnes',
        },
        {
          text: 'UBS',
          align: 'start',
          filterable: true,
          value: 'no_unidade_saude',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: true,
          value: 'nu_ine',
        },
        {
          text: 'Microárea',
          align: 'start',
          filterable: false,
          value: 'micro_area',
        },
        {
          text: 'Indicador',
          align: 'start',
          filterable: false,
          value: 'no_indicador',
        },
        {
          text: 'Percentual',
          align: 'start',
          filterable: false,
          value: 'resultado',
        },
        { text: '', value: 'data-table-expand' },
      ],
      periodo: null,
      optionsPeriodo: [],
      indicador: { label: 'CI e CDT atualizados', value: 33 },
      optionsIndicador: [...optionsIndicador],
      dataFieldsPercentual: {
        ...dataFieldsPercentual,
      },
      selectedCheckbox: [],
      selectedFiltro: 'microarea',
      optionsCheckbox: [
        { text: 'Município', value: 'municipio' },
        { text: 'Equipes', value: 'equipes' },
        { text: 'Microáreas', value: 'microarea' },
      ],
      dadosDaTabela: [],
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
        const periodos = Array.from(
          new Map(
            this.cadastros
              .filter((item) => item.mes_ano) // garante válido
              .map((item) => [
                item.mes_ano, // chave única
                {
                  mes_ano: item.mes_ano,
                  mes_ano_quad: item.mes_ano_quad,
                },
              ])
          ).values()
        )
        // ordenação desc
        periodos.sort((a, b) => {
          const [mesA, anoA] = a.mes_ano.split('/').map(Number)
          const [mesB, anoB] = b.mes_ano.split('/').map(Number)

          if (anoA !== anoB) return anoB - anoA
          return mesB - mesA
        })

        // monta options do select
        this.optionsPeriodo = periodos.map((p) => {
          const mes = Number(p.mes_ano.split('/')[0])
          const isQuad = [4, 8, 12].includes(mes)

          return {
            value: p.mes_ano,
            label: isQuad && p.mes_ano_quad ? p.mes_ano_quad : p.mes_ano,
          }
        })
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    indexedItems() {
      if (this.cadastros !== undefined) {
        return this.cadastros
          .filter((item) => {
            // Filtrar por indicador se selecionado
            const filterByIndicador = this.indicador
              ? item.indicador === this.indicador.value
              : true
            // Filtrar por período se selecionado
            const filterByPeriodo = this.periodo
              ? item.mes_ano === this.periodo.value
              : true
            // Filtrar por checkbox selecionado
            const filterByCheckbox = this.selectedCheckbox.length
              ? this.selectedCheckbox.some((checkboxValue) => {
                  if (checkboxValue === 'municipio') {
                    return item.nivel == 1
                  } else if (checkboxValue === 'equipes') {
                    return item.nivel == 2
                  } else if (checkboxValue === 'microarea') {
                    return item.nivel == 3
                  }
                  return false
                })
              : true
            return filterByIndicador && filterByPeriodo && filterByCheckbox
          })
          .map((item, index) => {
            return {
              id: index,
              ...item,
            }
          })
      }
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      return `table-row-color-${Functions.printTableRow(item)}`
    },

    onChangePeriodo(periodo) {
      this.indicador = { label: 'CI e CDT atualizados', value: 33 }
      this.selectedFiltro = 'microarea'
      this.filterData(periodo, this.indicador, this.selectedFiltro)
    },

    onChangeIndicador(indicador) {
      this.selectedFiltro = 'microarea'
      this.filterData(this.periodo, indicador, this.selectedFiltro)
    },

    onChangeFiltro(filtro) {
      this.filterData(this.periodo, this.indicador, filtro)
    },

    filterByCheckbox(cadastros, selectedFiltro) {
      if (selectedFiltro === 'municipio') {
        return cadastros.filter((el) => el.nivel == 1)
      } else if (selectedFiltro === 'equipes') {
        return cadastros.filter((el) => el.nivel == 2)
      } else if (selectedFiltro === 'microarea') {
        return cadastros.filter((el) => el.nivel == 3)
      }
      return cadastros
    },

    filterByPeriodo(data) {
      return data.filter((el) => {
        return el.mes_ano === this.periodo.value
      })
    },

    filterByIndicador(data, indicador) {
      return data.filter((el) => {
        return el.indicador === indicador.value
      })
    },

    filterData(periodo, indicador, filtro) {
      let data = this.cadastros
      if (periodo != null) {
        data = this.filterByPeriodo(data)
      }
      if (indicador != null) {
        data = this.filterByIndicador(data, indicador)
      }
      if (filtro != null) {
        data = this.filterByCheckbox(data, filtro)
      }
      this.dadosDaTabela = this.mapCadastros(data)
    },

    mapCadastros(cadastros) {
      return cadastros.map((item, index) => {
        return {
          id: index,
          ...item,
          indicador: item.no_indicador ?? '-',
          resultado:
            item.resultado && Number(item.resultado) !== 0
              ? item.resultado
              : '',
        }
      })
    },

    generatePdf() {
      let title_pdf = 'Resultado Municipal - Percentual'
      let titlePdfSave = this.titlePdf('Resultado Municipal - Percentual')

      let description_pdf =
        'Cidadãos e classificação por equipe no vínculo e acompanhamento.'
      let headers_pdf = [
        'CNES',
        'UBS',
        'INE',
        'MICROÁREA',
        'CIDADÃOS',
        'PERCENTUAL',
        'ATENÇÃO',
      ]
      var data_pdf = []
      for (let i = 0; i < this.dadosDaTabela.length; i++) {
        let item = this.dadosDaTabela[i]
        var obj = {}
        obj.nu_cnes = item.nu_cnes
        obj.no_unidade_saude = item.no_unidade_saude
        obj.nu_ine = item.nu_ine
        obj.micro_area = item.micro_area
        obj.cidadaos = item.cidadaos
        obj.resultado = item.resultado !== '' ? `${item.resultado}%` : ''
        obj.recomendacao_resultado = item.recomendacao_resultado
        data_pdf.push(obj)
      }

      let doc = new jsPDF(this.encryptionPdf())
      // cria a tabela
      let table = this.createTablePdf(data_pdf)
      this.fileToBase64(this.$store.state.infoMunicipio.brasao)
        .catch(() => '')
        .then((base64data) => {
          // Header
          let verticalPosition = this.headerPdf(
            doc,
            base64data,
            title_pdf,
            description_pdf
          )

          const filtro = this.selectedCheckbox
            .map((item) => {
              const corrections = {
                equipes: 'Equipes',
                microarea: 'Microáreas',
                municipio: 'Município',
              }
              return (
                corrections[item] ||
                item.charAt(0).toUpperCase() + item.slice(1)
              )
            })
            .join(', ')
          verticalPosition = this.bodyPdf(
            doc,
            [
              {
                label: 'Período',
                value: this.periodo?.label || this.periodo?.value || '',
              },
              {
                label: 'Indicador',
                value: this.indicador?.label ?? '',
              },
              {
                label: 'Filtro',
                value: filtro,
              },
            ],
            verticalPosition
          )

          doc.autoTable({
            head: [headers_pdf],
            body: table,
            headStyles: {
              fillColor: '#ccc',
              fontSize: 6,
              textColor: '#000',
              halign: 'center',
              cellWidth: 'wrap',
            },
            bodyStyles: {
              halign: 'center',
              fontSize: 6,
            },
            theme: 'striped',
            startY: verticalPosition,
            showHead: 'firstPage',
            willDrawCell: function (data) {},
          })

          this.footerPdf(doc, doc.autoTable.previous.finalY)

          doc.save(titlePdfSave + '.pdf')

          this.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
            position: 'topRight',
          })
        })
        .catch((error) => {
          console.error(error)
          this.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
            position: 'topRight',
          })
        })
    },
  },
}
</script>

<style>
.tabela .green-color {
  color: green !important;
}

.tabela .red-color {
  color: red !important;
}
</style>
<style scoped lang="scss">
.ultimo-acompanhamento {
  display: flex;
  align-items: center;
  // flex-direction: column;
  gap: 10px;

  span {
    background: #c4e8f6;
    color: #00aeef;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 11px;
  }
}
</style>
